module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00036-fs8.256c17e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00036-fs8.png
// module id = 189
// module chunks = 0